import _ from 'lodash';
import produce from 'immer';

import { defaultProcessingState } from '../utils';

import {
  API_TOKEN_FIND_START,
  API_TOKEN_FIND_FULFILL,
  API_TOKEN_FIND_REJECT,
  API_TOKEN_CREATE_START,
  API_TOKEN_CREATE_FULFILL,
  API_TOKEN_CREATE_REJECT,
  API_TOKEN_REMOVE_START,
  API_TOKEN_REMOVE_FULFILL,
  API_TOKEN_REMOVE_REJECT,
} from './api-token.actions';

const defaultState = {
  find: defaultProcessingState(),
  create: defaultProcessingState(),
  remove: defaultProcessingState(),
  data: {},
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case API_TOKEN_FIND_START: {
      ++draft.find.processing;
      return draft;
    }

    case API_TOKEN_FIND_FULFILL: {
      --draft.find.processing;
      draft.find.error = null;
      draft.data = _.keyBy(action.payload.result, 'id');
      return draft;
    }

    case API_TOKEN_FIND_REJECT: {
      --draft.find.processing;
      draft.find.error = action.payload;
      return draft;
    }

    case API_TOKEN_CREATE_START: {
      ++draft.create.processing;
      return draft;
    }

    case API_TOKEN_CREATE_FULFILL: {
      --draft.create.processing;
      draft.create.error = null;
      draft.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case API_TOKEN_CREATE_REJECT: {
      --draft.create.processing;
      draft.create.error = action.payload;
      return draft;
    }

    case API_TOKEN_REMOVE_START: {
      ++draft.remove.processing;
      return draft;
    }

    case API_TOKEN_REMOVE_FULFILL: {
      --draft.remove.processing;
      draft.remove.error = null;
      draft.data = _.omit(draft.data, [action.payload.result.id]);
      return draft;
    }

    case API_TOKEN_REMOVE_REJECT: {
      --draft.remove.processing;
      draft.remove.error = action.payload;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
